import http from "@seims/shared/src/services/HttpService";

var endpoint = `/stemi/`;
var dataEndpoint = `/data-migration${endpoint}`;

const uploadFile = async (file, onUploadProgress) => {
  var formData = new FormData();
  formData.append("file", file);

  const response = await http.post(`${dataEndpoint}upload`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress(progress.loaded / progress.total),
  });
  return response;
};

const getFile = async (id) => {
  const response = await http.get(`${dataEndpoint}upload/file${id}`, {
    responseType: "arraybuffer",
  });
  return response;
};

const getUploadHistory = async (isOwn) => {
  const response = await http.get(`${dataEndpoint}upload/history?own=${isOwn}`);
  return response;
}
const downloadOriginalFile = async (fileUuid) => {
  const response = await http.get(`${dataEndpoint}upload/original-file/${fileUuid}`, {responseType: "arraybuffer"});
  return response;
}
const downloadReport = async (reportUuid) => {
  const response = await http.get(`${dataEndpoint}upload/report/${reportUuid}`);
  return response;
};

const downloadOverviewReport = async (reportUuid) => {
  const response = await http.get(`${dataEndpoint}upload/overview/${reportUuid}`);
  return response;
};

const getRecordLimit = async () => {
  const response = await http.get(`${dataEndpoint}upload/record-limit`);
  return response;
};

const getOlympiadNames = async () => {
  const response = http.get(`${endpoint}olympiad-names`);
  return response;
}

const addOlympiadNames = async (data) => {
  const response = http.post(`${endpoint}olympiad-names`, data);
  return response;
}

const updateOlympiadName = async (uuid, data) => {
  const response = http.put(`${endpoint}olympiad-names/${uuid}`, data);
  return response;
}

const activateOlympiadName = async (data) => {
  const response = await http.patch(`${endpoint}olympiad-names/${data?.uuid}?active=${data?.active}` );
  return response;
}

export default {
  uploadFile,
  getFile,
  getUploadHistory,
  downloadOriginalFile,
  downloadReport,
  downloadOverviewReport,
  getRecordLimit,
  getOlympiadNames,
  addOlympiadNames,
  updateOlympiadName,
  activateOlympiadName,
};